import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function EmotionalClose() {
  return <section id="comprar" className="py-24 bg-white relative overflow-hidden" data-id="element-23">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-cream rounded-full blur-3xl -z-10 opacity-50" data-id="element-24" />

      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-26">
          <h2 className="text-3xl md:text-5xl font-serif mb-8 leading-tight" data-id="element-27">
            Tu bienestar también vive en los pequeños detalles.
          </h2>

          <div className="space-y-6 text-lg text-charcoal-light mb-12 leading-relaxed" data-id="element-28">
            <p data-id="element-29">
              A veces, dedicar unos minutos al día a observar, limpiar, secar y
              elegir mejor lo que usas puede ayudarte a sentir más calma, más
              orden y más conexión contigo.
            </p>
            <p data-id="element-30">
              Esta guía no busca complicarte. Busca acompañarte con una rutina
              simple, amable y fácil de sostener.
            </p>
          </div>

          <div className="flex justify-center" data-id="element-31">
            <Button showPrice href="https://rutina-guia.info-marketingdigital.com/cart/=53013386232124:1" className="px-12 py-5 text-lg" data-id="element-32">
              Descargar mi guía ahora
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}